const LoadingIndicator = () => (
    <div className="loading-container">
        <div className="loading-spinner"></div>
    </div>
);

export default LoadingIndicator;